import { FilterList } from "@mui/icons-material";
import { DatePicker } from "@mui/lab";
import {
  Badge,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CreatedTaskFilter({
  createdBy,
  associatedJob,
  setCreatedBy,
  setAssociatedJob,
  jobs,
  apUsers,
  deadline,
  setDeadline,
  onFilter,
  status,
  setStatus,
}) {
  const resetFilters = () => {
    setAssociatedJob("");
    setCreatedBy(null);
    setDeadline(null);
    setStatus(null);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const [count, setCount] = useState(0);
  useEffect(() => {
    let totalCount = 0;
    if (status) {
      totalCount += 1;
    }
    if (createdBy) {
      totalCount += 1;
    }

    if (associatedJob) {
      totalCount += 1;
    }

    if (deadline) {
      totalCount += 1;
    }

    setCount(totalCount);
  }, [status, createdBy, associatedJob, deadline]);
  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      {jobs && apUsers && (
        <Modal open={open} onClose={handleClose}>
          <Card sx={style} style={{ width: "500px" }}>
            <CardContent>
              <Paper>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="label"> Status</InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="label"
                        label="Select Status"
                        onChange={(e) => setStatus(e.target.value)}
                        value={status}
                      >
                        <MenuItem disabled value={""}>
                          Select Status To
                        </MenuItem>
                        <MenuItem value={"new"}>NEW</MenuItem>

                        <MenuItem value={"progress"}>IN-PROGRESS</MenuItem>

                        {/* <MenuItem value={"submit"}>SUBMIT</MenuItem> */}

                        <MenuItem value={"close"}>CLOSED</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                      options={apUsers}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) {
                          return options; // Show first 5 by default
                        }
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={
                        apUsers.find((c) => c._id === createdBy) || null
                      }
                      onChange={(e, newValue) =>
                        setCreatedBy(newValue?._id || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Assigned By"
                          placeholder="Search..."
                          variant="outlined"
                        />
                      )}
                      fullWidth
                      clearOnBlur={false}
                      sx={{
                        "& .MuiAutocomplete-listbox": {
                          maxHeight: 200,
                        },
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: "200px",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="label">Associate Job</InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="label"
                        label="Select Associated Job"
                        onChange={(e) => setAssociatedJob(e.target.value)}
                        value={associatedJob}
                      >
                        <MenuItem disabled value={""}>
                          Select Associated Job
                        </MenuItem>
                        {jobs.map((job) => {
                          return (
                            <MenuItem key={job._id} value={job._id}>
                              {job.job_id}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <DatePicker
                        name="deadline"
                        renderInput={(props) => <TextField {...props} />}
                        label="Deadline"
                        value={deadline}
                        onChange={(newValue) => {
                          let selectedDate = newValue;
                          var month = (
                            "0" + parseInt(selectedDate?.getMonth() + 1)
                          ).slice(-2);
                          var day = (
                            "0" + parseInt(selectedDate?.getDate())
                          ).slice(-2);
                          let date =
                            selectedDate?.getFullYear() +
                            "-" +
                            month +
                            "-" +
                            day;
                          setDeadline(date);
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <Button onClick={resetFilters} color="error">
                      Reset All Filter
                    </Button>
                  </Grid>
                  <Grid
                    container
                    justifyContent={"flex-end"}
                    item
                    xs={12}
                    md={6}
                    lg={6}
                  >
                    <Button
                      onClick={() => {
                        handleClose();
                        onFilter();
                      }}
                      color="success"
                    >
                      OK
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
        </Modal>
      )}
    </Paper>
  );
}

export default CreatedTaskFilter;
